<ng-select
  class="filter-dropdown"
  [ngClass]="{'hide-placeholder': showSelectedLabels}"
  [dropdownPosition]="dropdownPosition"
  [multiple]="true"
  [closeOnSelect]="false"
  [searchable]="searchable"
  [items]="items"
  [clearable]="clearable"
  [placeholder]="placeholder"
  [appendTo]="appendTo"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [(ngModel)]="selectedItems"
  (close)="updateFilter()"
  (clear)="clearFilter()"
>
  <ng-template ng-option-tmp let-item="item" let-item$="item$">
    <div>
      <mat-checkbox
        class="mr-1"
        color="primary"
        (click)="$event.preventDefault()"
        [checked]="item$.selected"
      ></mat-checkbox>
      {{ item[bindLabel] }}
    </div>
  </ng-template>

  <ng-template *ngIf="showSelectionCount" ng-multi-label-tmp let-items="items">
    <div *ngIf="items.length > 0" class="bg-selection-count">
      <span class="selection-count">{{ items.length }}</span>
    </div>
  </ng-template>
  <ng-template *ngIf="showSelectedLabels" ng-multi-label-tmp let-items="items">
    <div class="selected-labels w-100 pr-4 d-flex flex-row flex-nowrap">
      <div class="text-truncate">
        {{ items | collectionToString: bindLabel }}
      </div>
      <ng-container *ngIf="items.length > 1">({{ items.length - 1 }}+)</ng-container>
    </div>
  </ng-template>
</ng-select>
